// @flow
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ACTIVITY_AUDIENCE_TYPES } from '../lib/constants';
import FilterDropdownSelection from './FilterDropdownSelection';
import FilterDefaultLogo from './FilterDefaultLogo';

const defaultSelection = {
    title: 'All Athletes',
    teamIds: null,
    type: ACTIVITY_AUDIENCE_TYPES.TEAM
};

type Props = {
    filters: array<any>,
    onChange: any => any
};

export default function FilterDropdown({ filters, onChange }: Props) {
    const [isOpen, setIsOpen] = useState(false);
    const [selection, setSelection] = useState(defaultSelection);

    return (
        <React.Fragment>
            <div className="filter-box content-width">
                <div
                    tabIndex="0"
                    role="button"
                    aria-pressed="false"
                    className="filter-container"
                    onClick={() => {
                        setIsOpen(!isOpen);
                    }}
                    onKeyPress={(event: any) => {
                        const keyPressed = event.charCode;
                        if (keyPressed === 106 || keyPressed === 25) {
                            setIsOpen(true);
                        } else if (keyPressed === 13) {
                            setIsOpen(!isOpen);
                        }
                    }}
                    data-testid="dropdown-filter"
                >
                    {selection.logo ? (
                        <div
                            className={`logo ${
                                selection.isSelf ? 'profile-image' : 'team-logo'
                            }`}
                        >
                            <img alt={selection.title} src={selection.logo} />
                        </div>
                    ) : (
                        <FilterDefaultLogo />
                    )}
                    <div className="filter-title">{selection.title}</div>
                    <div className="spacer" />
                    <div>
                        <i className={`arrow ${isOpen ? 'up' : 'down'}`} />
                    </div>
                </div>

                <div
                    className={`filter-dropdown ${isOpen ? 'open' : 'closed'}`}
                >
                    {filters.map((selection: any, index: number) => {
                        return (
                            <FilterDropdownSelection
                                selection={selection}
                                index={index}
                                onSelect={() => {
                                    setIsOpen(false);
                                    setSelection(selection);
                                    onChange(selection);
                                }}
                            />
                        );
                    })}
                </div>
            </div>
            <div
                onClick={() => setIsOpen(false)}
                className={`filter-dropdown-background ${
                    isOpen ? 'open' : 'closed'
                }`}
            />
        </React.Fragment>
    );
}
